import { IconChevron } from '@components/icons';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { cn } from '@utils/cn';

import { AccordionBodyProps, AccordionHeaderProps, AccordionListProps, AccordionProps } from './accordion.types';

export const Accordion = ({ defaultOpen = false, children, className, ...props }: AccordionProps) => (
  <Disclosure
    as='div'
    defaultOpen={defaultOpen}
    className={cn(
      'overflow-hidden rounded-lg border bg-neutral-0 border-neutral-8 dark:bg-neutral-70 dark:border-neutral-50',
      className
    )}
    {...props}>
    {children}
  </Disclosure>
);

export const AccordionHeader = ({ children, className, showChevron = true, ...props }: AccordionHeaderProps) => (
  <DisclosureButton
    className={cn('w-full flex items-center justify-between px-4 py-3 text-neutral-70 dark:text-neutral-8', className)}
    {...props}>
    {({ open }) => (
      <>
        <div className='flex flex-1 text-inherit mr-4'>{children}</div>
        {showChevron && (
          <IconChevron
            aria-hidden='true'
            className={cn(
              'h-5 w-5 -mr-1 text-neutral-30 transition-transform dark:text-neutral-60',
              open ? 'rotate-90' : '-rotate-90'
            )}
          />
        )}
      </>
    )}
  </DisclosureButton>
);

export const AccordionBody = ({ children, className, ...props }: AccordionBodyProps) => (
  <DisclosurePanel className={cn('w-full text-sm px-4 pb-3 text-neutral-50 dark:text-neutral-0', className)} {...props}>
    {children}
  </DisclosurePanel>
);

export const AccordionList = ({ children, className, ...props }: AccordionListProps) => (
  <div
    className={cn(
      'rounded-lg *:rounded-none [&>*:first-child]:rounded-t-lg [&>*:last-child]:rounded-b-lg [&>*:not(:first-child)]:border-t-0',
      className
    )}
    {...props}>
    {children}
  </div>
);
